import React from 'react'
// import { TransitionGroup, CSSTransition } from "react-transition-group";

import project from '../../project'
import Data from './Data'
// import BreachCodes from './BreachCodes'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import { Tracking219 } from './Tracking'
// import VisibilitySensor from 'react-visibility-sensor'
// import { ajaxSetup, getJSON } from 'jquery'
import "../assets/styles/home.scss"

// ajaxSetup({ cache: true })

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.scrollDiv = React.createRef()
    this.state = {
      firstInteraction: false,
      appInViewport: false,
      data: undefined,
      breach: null,
      SubscriptionUrl: '',
      siteDomain: '',
      siteCode: '',
      activeCard: null,
      isMobApp: false
    }

    // this.siteCode = this.siteCode.bind(this);
    // this.checkBreach = this.checkBreach.bind(this);
    this.loadData = this.loadData.bind(this);
    this.visChange = this.visChange.bind(this);

    const thisState = this
    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('click', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
  }

  componentDidMount () {
    // this.checkBreach()
    this.loadData()
  }

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  /*siteCode (siteHostname) {
    let siteCode, siteDomain
    switch (siteHostname) {
      
      case 'www.adelaidenow.com.au' :
        siteCode = 'adv'
        siteDomain = 'adelaidenow'
        break
      
      case 'www.cairnspost.com.au' :
        siteCode = 'cp'
        siteDomain = 'cairnspost'
        break
      
      case  'www.couriermail.com.au' :
        siteCode = 'cm'
        siteDomain = 'couriermail'
        break
      
      case  'www.heraldsun.com.au' :
        siteCode = 'hs'
        siteDomain = 'heraldsun'
        break
      
      case  'www.geelongadvertiser.com.au' :
        rsiteCode = 'ga'
        siteDomain = 'geelongadvertiser'
        break
      
      case  'www.goldcoastbulletin.com.au' :
        siteCode = 'gcb'
        siteDomain = 'goldcoastbulletin'
        break

      case  'www.ntnews.com.au' :
        siteCode = 'ntn'
        siteDomain = 'ntnews'
        break

      case  'www.thechronicle.com.au' :
        siteCode = 'twc'
        siteDomain = 'thechronicle'
        break
      
      case  'www.themercury.com.au' :
        siteCode = 'merc'
        siteDomain = 'themercury'
        break
      
      case  'www.townsvillebulletin.com.au' :
        siteCode = 'tb'
        siteDomain = 'townsvillebulletin'
        break
      
      case  'www.weeklytimesnow.com.au' :
        siteCode = 'wtn'
        siteDomain = 'weeklytimesnow'
        break
      
      case  'www.dailytelegraph.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case 'localhost' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break
    }
    this.setState({
      siteCode: siteCode,
      siteDomain: siteDomain
    })

    return siteCode

  }
  */

  /*
  goLogin () {
    const loginButton = document.querySelectorAll('.header_log-in, .tgc-auth-buttons_login') // Mastheads, Regionals
    loginButton[0].click()
  }
  */

  /*
  checkBreach () {

    if (window.DNA_APP_ENV) {
      
      if (window.DNA_APP_ENV.platform) {
        this.state.breach = false
        this.state.isMobApp = true
        this.loadData()
      } else {
        setTimeout(this.checkBreach, 250);
      }

    } 

    if (window.utag_data) {
      if( (typeof window.utag_data.net_platform !== "undefined") && (typeof window.utag_data.pc_memtype !== "undefined") ) {
          const currentDomain = window.location.hostname
          const currentUrl = window.location.href
          const netsite = this.siteCode(window.location.hostname)
          const netplatform = window.utag_data.net_platform
          const breachSourceCode = BreachCodes[netsite][netplatform]
          const subUrl = 'https://'
            + currentDomain
            + '/subscribe/news/1/'
            + '?sourceCode=' + breachSourceCode
            + '&dest=' + encodeURIComponent(currentUrl)
            + '&memtype=anonymous&mode=premium'

          this.state.SubscriptionUrl = subUrl
          this.state.breach = ( utag_data && utag_data.pc_memtype == "subscriber" ) ? false : true;
          this.loadData()
      }
      else {
          setTimeout(this.checkBreach, 250);
      }
      
    }
    
  }
  */

  /*
  dataSlash () {
    let slashedData = []
    const items = this.state.data

    items.forEach(function(item){
      if ( item.id <= 2 ) {
        slashedData.push(item)
      } else {
        item.t1 = ''
        item.t2 = ''
        item.t3 = ''
        item.t4 = ''
        item.t5 = ''
        item.t6 = ''
        item.t7 = ''
        item.t8 = ''
        item.premier = ''
        item.spoon = ''
        item.brownlow = ''
        item.coleman  = ''
        item.rising = ''
        item.prediction = ''
        slashedData.push(item)
      }
      
    })

    this.setState({
      data: slashedData
    })

  }
  */

  /*
  scroll2message () {
    this.scrollDiv.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  */

  /*
  goSubscribe () {
    window.location.replace(this.state.SubscriptionUrl);
  }
  */

  loadData () {
    this.setState({
      data: Data
    }, function () {
      if ( this.state.breach === true ) {
        // this.dataSlash()
      }
    });
  }

  expandCard (e, id) {
    
    if ( ( this.state.breach === true ) && ( id > 2 ) )  {
      this.closeCard()
      return
    }
    
    const targetRow = e.target.closest('.nnd-row')
    const targetSection = targetRow.querySelector('.nnd-col-text-content')
    const targetSectionHeight = targetSection.offsetHeight
    const targetImage = targetRow.querySelector('.nnd-cta')
    const targetImageHeight = targetImage.offsetHeight
    const existActiveRow = document.querySelector(".nnd-row.nnd-active")

    console.log('targetRow', targetRow)
    console.log('targetSection', targetSection)
    console.log('targetSectionHeight', targetSectionHeight)
    console.log('targetImage', targetImage)
    console.log('targetImageHeight', targetImageHeight)
    console.log('existActiveRow', existActiveRow)
    console.log('-----')

    if ( targetRow === this.state.activeCard ) {
      targetRow.classList.toggle(`nnd-active`)
      
      this.setState({
        activeCard: null
      }, function () {
        // targetRow.style.height = targetImageHeight + 'px'
      });

    } else {
      
      if (existActiveRow) {
        // const existActiveRowImageHeight = existActiveRow.querySelector('.nnd-col-img').offsetHeight
        existActiveRow.classList.toggle(`nnd-active`)
        // existActiveRow.style.height = existActiveRowImageHeight + 'px'
      }

      this.setState({
        activeCard: targetRow
      }, function () {
        const currentCard =  this.state.activeCard
        currentCard.classList.toggle(`nnd-active`)
        // currentCard.style.height = targetImageHeight + 'px'
        // targetRow.style.height = ( targetSectionHeight + targetImageHeight )+ 'px'
      });

    }
  }

  closeCard () {
    const existActiveRow = document.querySelector(".nnd-row.nnd-active")
    if (existActiveRow) {
      
      this.setState({
        activeCard: null
      }, function () {
        // const existActiveRowImageHeight = existActiveRow.querySelector('.nnd-col-img').offsetHeight
        existActiveRow.classList.toggle(`nnd-active`)
        // existActiveRow.style.height = existActiveRowImageHeight + 'px'
        // this.scroll2message()
      });

    } else {
      // this.scroll2message()
    }
    
  }

  render() {
    const mylist = (typeof this.state.data !== 'undefined') ? this.state.data.map((item) => {
      if (typeof this.state.data !== 'undefined') {
        return (
         <div key={item.id} className={`nnd-row nnd-goal-${item.id}`} >
           
            <div className="nnd-cta" onClick={(e) => { this.expandCard(e, item.id); e.preventDefault() }}>
              <h4 className="nnd-cta-name">{ item.id }</h4>
            </div>
           
           <section className="nnd-col-text">
             <div className="nnd-col-text-content">
                <h4><span className="nnd-number">{item.id}</span><span className="nnd-title">{ item.heading }</span></h4>
                <div className="nnd-col-text-inner">
                  <p className="nopad">Goal number: <span>{ item.goalnumber }</span></p>
                  <p className="nopad">For { item.for } against {item.against}</p>
                  <p className="nopad"> { item.game }</p>
                  <p className=" borderTop">{ item.copy }</p>
                </div>
                <div className="nnd-cta-icon" data-index={item.id} onClick={(e) => { this.expandCard(e, item.id); e.preventDefault() }}>
                  <div className="nnd-cta-icon_plus"></div>
                  <div className="nnd-cta-icon_plus_vertical"></div>
                </div>
             </div>
             
           </section>

         </div>
        )
      }
    }) : ''

    const isActiveCard = this.state.activeCard

    return (
      <div className={'nnd-container'}>
        <div className="nnd-header">
          <h3>Relive Lance Franklin’s best 23 goals as he closes in on 1000</h3>
        </div>
        <div className={isActiveCard !== null ? 'nnd-cont-main nnd-activeCard' : 'nnd-cont-main'}>
          <div className="nnd-oval"></div>
          {mylist}
        </div>
        <p className="nnd-note">* Black dots represent the position of all goals kicked by Lance Franklin</p>
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js